module.exports = __webpack_public_path__ + "img/status_failed_black.c10887fd.png";